/** @format */
import React from "react";
import axios from "axios";
import "./App.css";
import {
  Routes,
  Route,
  // useNavigate,
  // useLocation,
  Navigate,
} from "react-router-dom";
import { useEffect } from "react";
import { useContext } from "react";
import Layout from "./components/Layout";
import SignupPage from "./components/SignupPage";
import ProfilePage from "./components/ProfilePage";
import Loginpage from "./components/Loginpage";
import Changepassword from "./components/Changepassword";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import Content from "./components/Content";
import Visualization from "./components/Visualization";
import Barchart from "./components/datavisualization/Barchart";
import Piechart from "./components/datavisualization/Piechart";
import Treemapchart from "./components/datavisualization/Treemapchart";
import TomorrowBarchart from "./components/datavisualization/CancerTomorrow/Barchart";
import TomorrowLinechart from "./components/datavisualization/CancerTomorrow/Linechart";
import OvertimeBarchart from "./components/datavisualization/CancerOvertime/Barchart";
import OvertimeLinechart from "./components/datavisualization/CancerOvertime/Linechart";
import TableComponent from "./components/TableComponent";
import Datavisualization from "./components/Datavisualization";
import { AuthContext } from "./components/AuthContext";
import CMSPagesComponent from "./components/CMSPagesComponent";
import CancerTomorrow from "./components/CancerTomorrow";
import CancerOvertime from "./components/CancerOvertime";
import Factsheets from "./components/Factsheets";
import HelpSection from "./components/HelpSection";
import InactivityHandler from "./components/InactivityHandler";

const App = () => {
  //Globally Declaring axios baseURL

  //Local Base API URL
  // axios.defaults.baseURL = "http://127.0.0.1:8000/api";
  // axios.defaults.baseURL = "http://192.168.29.3:8000/api";
  //Production Base API URL
  axios.defaults.baseURL =
    "https://tn-crest.cancerinstitutewia.in/tncrp-backend-prod/api";
  // axios.defaults.baseURL =
  //   "https://www.evolvebizcon.com/tncrp-backend_qa/public/api";
  axios.defaults.withCredentials = false;

  const { setIsAuthenticated } = useContext(AuthContext);
  const { isAuthenticated } = useContext(AuthContext);

  //ProtectedRoute wrapper
  const ProtectedRoute = ({ children }) => {
    const token = sessionStorage.getItem("token");
    return token ? children : <Navigate to="/Login" />;
  };

  useEffect(() => {
    const authToken = sessionStorage.getItem("token");
    if (authToken) {
      setIsAuthenticated(true);
    }
  }, [setIsAuthenticated]);
  const handleLogout = () => {
    sessionStorage.clear();
    window.location.href = "/login";
    // window.location.href = "adyar_qa/login";
  };

  return (
    <>
      {isAuthenticated && (
        <InactivityHandler
          timeout={20 * 60 * 1000}
          promptDuration={60 * 1000}
          onLogout={handleLogout}
        />
      )}
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Content />} />
          <Route path="/login" element={<Loginpage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/factsheets" element={<Factsheets />} />
          <Route path="/pages/help" element={<HelpSection />} />
          <Route
            path="/pages/:page_shortname"
            element={<CMSPagesComponent />}
          ></Route>
          {/* Protected Routes */}

          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/changepassword"
            element={
              <ProtectedRoute>
                <Changepassword />
              </ProtectedRoute>
            }
          />
          <Route
            path="/visualization"
            element={
              <ProtectedRoute>
                <Visualization />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CancerTomorrow"
            element={
              <ProtectedRoute>
                <CancerTomorrow />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cancertomorrow/barchart"
            element={
              <ProtectedRoute>
                <TomorrowBarchart />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cancertomorrow/linechart"
            element={
              <ProtectedRoute>
                <TomorrowLinechart />
              </ProtectedRoute>
            }
          />
          <Route
            path="/CancerOvertime"
            element={
              <ProtectedRoute>
                <CancerOvertime />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cancerovertime/barchart"
            element={
              <ProtectedRoute>
                <OvertimeBarchart />
              </ProtectedRoute>
            }
          />
          <Route
            path="/cancerovertime/linechart"
            element={
              <ProtectedRoute>
                <OvertimeLinechart />
              </ProtectedRoute>
            }
          />
          <Route
            path="/TableComponent"
            element={
              <ProtectedRoute>
                <TableComponent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/barchart"
            element={
              <ProtectedRoute>
                <Barchart />
              </ProtectedRoute>
            }
          />
          <Route
            path="/piechart"
            element={
              <ProtectedRoute>
                <Piechart />
              </ProtectedRoute>
            }
          />
          <Route
            path="/treemapchart"
            element={
              <ProtectedRoute>
                <Treemapchart />
              </ProtectedRoute>
            }
          />
          <Route
            path="/datavisualization"
            element={
              <ProtectedRoute>
                <Datavisualization />
              </ProtectedRoute>
            }
          />
        </Route>
      </Routes>
    </>
  );
};
export default App;
